/**
 * The cache key All Contacts' list lives under.
 *
 * It starts with `"contacts"`, so every contact write — which refreshes
 * `["contacts"]` as a whole — refreshes this list with it. A customer write
 * (`customers/useCustomerAnnotations.ts`) does not, so it names this key too:
 * the list shows the customer's tags.
 */
export const DIRECTORY_KEYS = {
  list: ["contacts", "directory"] as const,
};
